import { Injectable } from "@angular/core";
import { AuthHttpService } from "app/users";
import { getApiPath } from "app/common";

export type YousignFlowType = "vollmacht" | "payment-instruction";

// i18n keys of the title Yousign shows atop its signing iframe (the signature request name).
export const YOUSIGN_SIGNATURE_NAME_KEYS: Record<YousignFlowType, string> = {
  vollmacht: "YOUSIGN.SIGNATURE_NAME_VOLLMACHT",
  "payment-instruction": "YOUSIGN.SIGNATURE_NAME_PAYMENT_INSTRUCTION"
};

@Injectable({
  providedIn: "root"
})
export class YousignHttpService {
  constructor(private authHttp: AuthHttpService) {}

  public getYousignSDK() {
    return this.authHttp.get(`${getApiPath()}yousign/sdk/`, {
      responseType: "text" as "json"
    });
  }

  public initYousign(statementpk: number, flowType: YousignFlowType = "vollmacht", signatureName?: string) {
    const options = signatureName ? { params: { signature_name: signatureName } } : {};

    if (flowType === "payment-instruction") {
      return this.authHttp.get(`${getApiPath()}yousign/${statementpk}/payment-instruction/init/`, options);
    }

    return this.authHttp.get(`${getApiPath()}yousign/${statementpk}/init/`, options);
  }

  public yousignCheckStatus(statementpk: number, flowType: YousignFlowType = "vollmacht") {
    if (flowType === "payment-instruction") {
      return this.authHttp.get(`${getApiPath()}yousign/${statementpk}/payment-instruction/check-status/`);
    }

    return this.authHttp.get(`${getApiPath()}yousign/${statementpk}/check-status/`);
  }
}
